import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationWho() {
  /* ====================================
  # Timeline線画アニメーション + 丸フェードイン
  ==================================== */
  
  // タイムライン要素を取得
  const timeline = document.querySelector('.p-who-history__timeline');
  const timelineItems = document.querySelectorAll('.p-who-history__item');
  
  if (!timeline || timelineItems.length === 0) return;
  
  // 初期設定：線の高さを0に設定
  gsap.set(timeline, {
    '--line-height': '0%',
  });
  
  // 初期設定：すべての丸を非表示に設定
  timelineItems.forEach((item) => {
    gsap.set(item, {
      '--circle-opacity': '0',
      '--circle-scale': '0',
    });
  });
  
  // CSS変数を使った線のアニメーション（線の先端が画面中央に追従）
  ScrollTrigger.create({
    trigger: timeline,
    start: 'top bottom',
    end: 'bottom top',
    scrub: true,
    onUpdate: (self) => {
      // タイムライン要素の位置情報を取得
      const timelineRect = timeline.getBoundingClientRect();
      const timelineTop = timelineRect.top + window.scrollY;
      
      // サマリー要素を取得してその位置まで線を伸ばす
      const summaryElement = document.querySelector('.p-who-history__summary');
      let maxLineHeight = timelineRect.height; // デフォルトはタイムライン高さ
      
      if (summaryElement) {
        const summaryRect = summaryElement.getBoundingClientRect();
        const summaryTop = summaryRect.top + window.scrollY;
        // タイムライン開始位置からサマリー開始位置までの距離を計算
        maxLineHeight = summaryTop - timelineTop;
      }
      
      // ビューポートの中央位置を計算
      const viewportCenter = window.scrollY + (window.innerHeight / 2);
      
      // タイムライン開始位置からビューポート中央までの距離を計算
      const distanceFromStart = Math.max(0, viewportCenter - timelineTop);
      
      // 線の高さをピクセル値で計算（最大はサマリー位置まで）
      const lineHeight = Math.min(distanceFromStart, maxLineHeight);
      
      // CSS変数に設定
      gsap.set(timeline, {
        '--line-height': `${lineHeight}px`,
      });
    }
  });
  
  // 各アイテムの丸のフェードイン + スケールアニメーション
  timelineItems.forEach((item, index) => {
    // 丸のアニメーション
    gsap.to(item, {
      '--circle-opacity': '1',
      '--circle-scale': '1',
      duration: 0.6,
      ease: 'back.out(1.7)',
      scrollTrigger: {
        trigger: item,
        start: 'top center',
        end: 'bottom center',
        toggleActions: 'play none none reverse',
      }
    });
  });
} 